import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IAddAdminRequest } from '../models/add-admin.model';

export const loadAddAdmins = createAction('[AddAdmin] Load AddAdmins', props<{ request: IAddAdminRequest; businessId: string }>());

export const loadAddAdminsSuccess = createAction('[AddAdmin] Load AddAdmins Success', props<{ response: string }>());

export const loadAddAdminsFailure = createAction('[AddAdmin] Load AddAdmins Failure', props<{ error: IGenericError<ErrorResponse> }>());
